import React from 'react';

class ExternalLink extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	render() {
		if (this.props.dependentValues && this.props.dependentValues.url)
		{
			let url = this.props.dependentValues.url;
			if (!url.startsWith("http://") && !url.startsWith("https://") && !url.startsWith("ftp://"))
				url = "http://" + url;
			
			return (
				<React.Fragment>
					<a style={this.props.dependentValues.style} 
						target={ this.props.dependentValues.targetBlank ? "_blank" : ""}
						href={url} 
						onClick={e => this.handleClick(e)}>
							{this.props.dependentValues.title}
					</a>
				</React.Fragment>)
		}
		else if (this.props.value)
			return this.props.value;
		else
			return null;
	}
}

export default ExternalLink;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/ExternalLink.js